/**
 * 生成指定长度的随机字母数字组合
 * @param length 需要生成的长度
 * @returns 随机字母数字组合
 */
export function generateRandomString(length: number): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

/**
 * 生成预算ID
 * @returns 格式为 BUDGET_XXXXXXXXXX 的预算ID
 */
export function generateBudgetId(): string {
  return `BUDGET_${generateRandomString(10)}`;
}

export const generateBudgetItemId = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = 'BUDGETITEM_';
  for (let i = 0; i < 10; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}; 